type EntryProfile = {
  id: number;
  email: string;
};

const normalizeEmail = (email?: string) => email?.trim().toLowerCase() ?? '';

export const resolveEntryProfileId = (
  profiles: EntryProfile[],
  currentUserEmail: string | undefined,
  isAdmin: boolean,
  preferredProfileId?: number,
) => {
  if (isAdmin) {
    return profiles.some(profile => profile.id === preferredProfileId)
      ? preferredProfileId ?? 0
      : profiles[0]?.id ?? 0;
  }

  const normalizedUserEmail = normalizeEmail(currentUserEmail);
  const currentUserProfile = normalizedUserEmail
    ? profiles.find(profile => normalizeEmail(profile.email) === normalizedUserEmail)
    : undefined;

  if (currentUserProfile) {
    return currentUserProfile.id;
  }

  return profiles.length === 1 ? profiles[0].id : 0;
};
